"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AppConstants = _interopRequireDefault(require("../../constants/AppConstants"));
var _downloadFile = _interopRequireDefault(require("./downloadFile"));
var _saveHandler = _interopRequireDefault(require("./saveHandler"));
var _CallbackTypes = _interopRequireDefault(require("../../constants/CallbackTypes"));
var _ServiceRegistry = _interopRequireDefault(require("../../util/ServiceRegistry"));
var _LoggingService = require("../../service/LoggingService");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
const logInfo = obj => {
  const message = obj && obj.message ? obj.message : "";
  _ServiceRegistry.default.getService("LoggingService").info("saveFile", _LoggingService.LoggingConstants.SAVE_API, message);
};
const saveFile = (options = {}, saveType = _AppConstants.default.SAVE_COMMENT_TYPE.MANUAL) => new Promise((saveResolve, saveReject) => {
  const saveMethod = (opt, type) => new Promise((resolve, reject) => {
    const appStore = _ServiceRegistry.default.getService("AppStore");
    if (appStore.fileStatus === _AppConstants.default.FILE_PROGRESS_STATUS.SAVING) {
      reject();
    } else {
      appStore.setFileStatus(_AppConstants.default.FILE_PROGRESS_STATUS.SAVING);
      appStore.setIsDirty(false);
      const success = metadata => {
        const fileId = appStore.fileInfoList[0].id;
        appStore.setFileStatus(_AppConstants.default.FILE_PROGRESS_STATUS.SAVED);
        if (appStore.fileInfoList[0].asset) {
          appStore.setUseAcrobatJs(false);
          appStore.removeAsset(fileId);
        }
        if (metadata) {
          appStore.setFileMetadata(fileId, metadata);
          resolve(metadata);
          if (metadata.version) {
            _ServiceRegistry.default.getService("CommandManager").notifyAssetVersionUpdate(_objectSpread(_objectSpread({}, metadata), {}, {
              fileId
            }));
          }
        } else {
          resolve();
        }
      };
      const fail = err => {
        logInfo(err);
        appStore.setFileStatus(_AppConstants.default.FILE_PROGRESS_STATUS.FAILED);
        appStore.setIsDirty(true);
        appStore.setAppError(err);
        reject(err);
      };
      const callbackService = _ServiceRegistry.default.getService("CallbackService");
      if (callbackService.hasCallback(_CallbackTypes.default.SAVE_API)) {
        (0, _saveHandler.default)(opt, type).then(metadata => success(metadata)).catch(err => fail(err));
      } else {
        (0, _downloadFile.default)().then(() => success()).catch(err => fail(err));
      }
    }
  });

  // commit any pending changes and then save it.
  const appStore = _ServiceRegistry.default.getService("AppStore");
  const hasAnnotationTools = !appStore.shouldHideAnnotationTools;
  const isThumbnailView = appStore.configStore.isThumbnailView;
  const isInPreview = appStore.isInPreview;
  const isFullFileLoaded = appStore.isFullFileLoaded();
  const preSaveCommit = isInPreview && !isThumbnailView && hasAnnotationTools && isFullFileLoaded ? () => _ServiceRegistry.default.getService("CommentsApi").commitUnsavedChanges() : () => Promise.resolve();
  preSaveCommit().finally(() => {
    if (appStore.isDirty) {
      saveMethod(options, saveType).then(response => {
        saveResolve(response);
      }).catch(err => {
        saveReject(err);
      });
    } else {
      saveResolve();
    }
  });
});
var _default = exports.default = saveFile;